import { render } from "./FlowWrapper.vue?vue&type=template&id=2d4aff62"
import script from "./FlowWrapper.vue?vue&type=script&lang=js"
export * from "./FlowWrapper.vue?vue&type=script&lang=js"
script.render = render

export default script